import React from 'react';

const BS_Glyphicons = () => {
    return (
        <div>
            <h1>BS_Glyphicons Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_Glyphicons;
